import React from 'react'
import * as yup from 'yup'
import { FormattedMessage } from 'react-intl'


// let userRegex = /^[a-z0-9_]{8,16}$/g
export const LoginFormValidation = yup.object().shape({
  email: yup.string()
    .email(<FormattedMessage id='validationSchema.validEmail' />)
    .required(<FormattedMessage id='validationSchema.required' />),
  password: yup.string().required(<FormattedMessage id='validationSchema.required' />)
})

export const additionalInfoFormValidation = yup.object().shape({
  socialNumber: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />)
    .matches(/^[0-9]+$/, { message: <FormattedMessage id='validationSchema.socialNumberOnlyNumbers' /> })
    .matches(/(2|3)[0-9][0-9][0-1][0-9][0-3][0-9](01|02|03|04|05|06|07|08|09|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)\d\d\d\d\d/, {
      message: <FormattedMessage id='validationSchema.socialNumberInvalid' />
    })
    .min(14, <FormattedMessage id='validationSchema.socialNumberLengthMin' />)
    .max(14, <FormattedMessage id='validationSchema.socialNumberLengthMax' />),
  roles: yup.array().nullable().min(1, <FormattedMessage id='validationSchema.required' />),
  country: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  government: yup.string().trim(),
  city: yup.string().trim(),
  address_line1: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  address_line2: yup.string().trim()
})
export const additionalSubscriptionInfoFormValidation = yup.object().shape({
  roles: yup.array().nullable().min(1, <FormattedMessage id='validationSchema.required' />)
})

export const userListFilterFormValidation = yup.object().shape({
  username: yup.string().max(3, <FormattedMessage id='validationSchema.userNameLengthMax' />),
  email: yup.string()
    .email(<FormattedMessage id='validationSchema.validEmail' />),
  national_id: yup.string().trim()
    .matches(/^[0-9]+$/, { message: <FormattedMessage id='validationSchema.socialNumberOnlyNumbers' /> })
    .max(14, <FormattedMessage id='validationSchema.socialNumberLengthMax' />),
  phone: yup.string().trim()
    .matches(/^\+(?:[0-9] ?){6,14}[0-9]$/, { message: <FormattedMessage id='validationSchema.phoneNumber' /> })
})

export const addAdminFormValidation = yup.object().shape({
  username: yup.string()
    .required(<FormattedMessage id='validationSchema.required' />)
    .matches(
      /^[a-z](_(?!(_))|[a-z0-9]){6,10}[a-z0-9]$/g,
      { message: <FormattedMessage id='validationSchema.username' /> }
    ),
  email: yup.string()
    .email(<FormattedMessage id='validationSchema.validEmail' />)
    .required(<FormattedMessage id='validationSchema.required' />),
  first_name: yup.string().trim(),
  last_name: yup.string().trim()
})

export const pageFormValidation = yup.object().shape({
  title: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  slug: yup.string()
    .required(<FormattedMessage id='validationSchema.required' />)
    .matches(
      /^[a-z](_(?!(_))|-(?!(-))|[a-z0-9]){1,}[a-z0-9]$/g,
      { message: <FormattedMessage id='validationSchema.slug' /> }
    ),
  content: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />)
})
export const categoryFormValidation = yup.object().shape({
  name: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  description: yup.string()
})
export const serviceFormValidation = yup.object().shape({
  title: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  description: yup.string(),
  category_id: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  handler_name: yup.string().trim(),
  active: yup.boolean(),
  allowed_taxes_monthly: yup.string().when('allowed_taxes', (allowedTaxes) => {
    return (!!allowedTaxes) ? yup.array().nullable(false).required(<FormattedMessage
      id='validationSchema.required' />).min(1,
        <FormattedMessage id='validationSchema.required' />) : yup.array()
  }),
  allowed_taxes_quarterly: yup.string().when('allowed_taxes', (allowedTaxes) => {
    return (!!allowedTaxes) ? yup.array().nullable(false).required(<FormattedMessage
      id='validationSchema.required' />).min(1,
        <FormattedMessage id='validationSchema.required' />) : yup.array()
  }),
  allowed_taxes_midterm: yup.string().when('allowed_taxes', (allowedTaxes) => {
    return (!!allowedTaxes) ? yup.array().nullable(false).required(<FormattedMessage
      id='validationSchema.required' />).min(1,
        <FormattedMessage id='validationSchema.required' />) : yup.array()
  }),
  allowed_taxes_annually: yup.string().when('allowed_taxes', (allowedTaxes) => {
    return (!!allowedTaxes) ? yup.array().nullable(false).required(<FormattedMessage
      id='validationSchema.required' />).min(1,
        <FormattedMessage id='validationSchema.required' />) : yup.array()
  }),
  price_monthly: yup.number().when('is_quota_based', (isQuota) => {
    return (!!isQuota) ? yup.string() : yup.number().min(0, <FormattedMessage
      id='validationSchema.positive' />)
  }),
  price_quarterly: yup.number().when('is_quota_based', (isQuota) => {
    return (!!isQuota) ? yup.string() : yup.number().min(0, <FormattedMessage
      id='validationSchema.positive' />)
  }),
  price_midterm: yup.number().when('is_quota_based', (isQuota) => {
    return (!!isQuota) ? yup.string() : yup.number().min(0, <FormattedMessage
      id='validationSchema.positive' />)
  }),
  price_annually: yup.number().when('is_quota_based', (isQuota) => {
    return (!!isQuota) ? yup.string() : yup.number().min(0, <FormattedMessage
      id='validationSchema.positive' />)
  }),
  quota_unit: yup.string().when('is_quota_based', (isQuota) => {
    return (!!isQuota) ? yup.string().trim().required(<FormattedMessage id='validationSchema.required' />) : yup.string()
  }),
  quotaPrices: yup.array().when('is_quota_based', (isQuota) => {
    return (!!isQuota) ? yup.array().nullable(false).required(<FormattedMessage id='validationSchema.required' />).min(1,
      <FormattedMessage id='validationSchema.required' />) : yup.array()
  })
}).test('pricesPlan', null, (obj) => {
  if (!!obj.is_quota_based || [obj.price_monthly, obj.price_quarterly, obj.price_midterm, obj.price_annually].filter(value => value >= 0).length > 0) {
    return true // everything is fine
  }
  return new yup.ValidationError(<FormattedMessage
    id='validationSchema.pricesPlan.service' />, null, 'pricesPlan')
})

export const planFormValidation = yup.object().shape({
  title: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  description: yup.string(),
  active: yup.boolean(),
  services: yup.array().nullable().min(1, <FormattedMessage id='validationSchema.required' />),
  allowed_taxes_monthly: yup.string().when('allowed_taxes', (allowedTaxes) => {
    return (!!allowedTaxes) ? yup.array().nullable(false).required(<FormattedMessage
      id='validationSchema.required' />).min(1,
        <FormattedMessage id='validationSchema.required' />) : yup.array()
  }),
  allowed_taxes_quarterly: yup.string().when('allowed_taxes', (allowedTaxes) => {
    return (!!allowedTaxes) ? yup.array().nullable(false).required(<FormattedMessage
      id='validationSchema.required' />).min(1,
        <FormattedMessage id='validationSchema.required' />) : yup.array()
  }),
  allowed_taxes_midterm: yup.string().when('allowed_taxes', (allowedTaxes) => {
    return (!!allowedTaxes) ? yup.array().nullable(false).required(<FormattedMessage
      id='validationSchema.required' />).min(1,
        <FormattedMessage id='validationSchema.required' />) : yup.array()
  }),
  allowed_taxes_annually: yup.string().when('allowed_taxes', (allowedTaxes) => {
    return (!!allowedTaxes) ? yup.array().nullable(false).required(<FormattedMessage
      id='validationSchema.required' />).min(1,
        <FormattedMessage id='validationSchema.required' />) : yup.array()
  }),
  price_monthly: yup.number().min(0, <FormattedMessage id='validationSchema.positive' />),
  price_quarterly: yup.number().min(0, <FormattedMessage id='validationSchema.positive' />),
  price_midterm: yup.number().min(0, <FormattedMessage id='validationSchema.positive' />),
  price_annually: yup.number().min(0, <FormattedMessage id='validationSchema.positive' />)
}).test('pricesPlan', null, (obj) => {
  if ([obj.price_monthly, obj.price_quarterly, obj.price_midterm, obj.price_annually].filter(value => value >= 0).length > 0) {
    return true // everything is fine
  }
  return new yup.ValidationError(<FormattedMessage
    id='validationSchema.pricesPlan.plan' />, null, 'pricesPlan')
})
export const roleFormValidation = yup.object().shape({
  name: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  permissions: yup.array().min(1, <FormattedMessage id='validationSchema.required' />)
})
export const settingFormValidation = (isIncentive, isUIN, isText) => yup.object().shape({
  value: !!isIncentive
    ? yup.string().trim().required(<FormattedMessage id='validationSchema.required' />)
    : !!isUIN ? yup.array().min(1, <FormattedMessage id='validationSchema.required' />)
      : !!isText ? yup.string().trim().required(<FormattedMessage id='validationSchema.required' />)
        : yup.number()
          .required(<FormattedMessage id='validationSchema.required' />)
          .positive(<FormattedMessage id='validationSchema.positive' />)
          .integer(<FormattedMessage id='validationSchema.integer' />)
})

export const UPTCPFormValidation = yup.object().shape({
  file: yup.mixed().required(<FormattedMessage id='validationSchema.required' />)
})

export const userGroupFormValidation = yup.object().shape({
  name: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  users: yup.array().min(1, <FormattedMessage id='validationSchema.required' />)
})

export const currencyFormValidation = yup.object().shape({
  name: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  key: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  code: yup.number().nullable()
    .required(<FormattedMessage id='validationSchema.required' />)
    .positive(<FormattedMessage id='validationSchema.positive' />),
  enable_core: yup.boolean(),
  core_sender_id: yup.string().trim().when('enable_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  core_sender_default_name: yup.string().trim().when('enable_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  core_sender_password: yup.string().trim().when('enable_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  core_service_code: yup.string().trim().when('enable_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  core_settlement_amount_code: yup.string().trim().when('enable_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  enable_none_core: yup.boolean(),
  none_core_sender_id: yup.string().trim().when('enable_none_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  none_core_sender_default_name: yup.string().trim().when('enable_none_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  none_core_sender_password: yup.string().trim().when('enable_none_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  none_core_service_code: yup.string().trim().when('enable_none_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  }),
  none_core_settlement_amount_code: yup.string().trim().when('enable_none_core', {
    is: true,
    then: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
    otherwise: yup.string().trim()
  })
})
export const externalEntityGroupFormValidation = yup.object().shape({
  name: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  entity_type: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  entity_references: yup.array().min(1, <FormattedMessage id='validationSchema.required' />)
})
export const PromocodeFormValidation = yup.object().shape({
  title: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  code: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  start_date: yup.string().trim(),
  end_date: yup.string().trim(),
  discount_type: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
  usage_limit: yup.number().nullable()
    .min(0, <FormattedMessage id='validationSchema.positive' />)
    .integer(<FormattedMessage id='validationSchema.integer' />),
  discount_value: yup.number()
    .min(0, <FormattedMessage id='validationSchema.positive' />)
    .when('discount_type', {
      is: (val) => val === 'percentage',
      then: (schema) => schema.max(100, <FormattedMessage id='validationSchema.discountValue.maxPercentage' />),
    })
    .required(<FormattedMessage id='validationSchema.required' />),
  max_discount: yup.number().nullable()
    .min(0, <FormattedMessage id='validationSchema.positive' />),
  rules: yup.array()
    .of(
      yup.object().shape({
        external_entity_type: yup.string().nullable()
          .transform((value, originalValue) => originalValue === '' ? null : value),
        external_entity_reference: yup.string().nullable()
          .transform((value, originalValue) => originalValue === '' ? null : value)
          .when('external_entity_type', {
            is: (val) => val && val.trim() !== '',
            then: (schema) => schema.trim().required(<FormattedMessage id='validationSchema.required' />),
            otherwise: (schema) => schema
          }),
        payables: yup.array().of(
          yup.object().shape({
            payable_type: yup.string().trim().required(<FormattedMessage id='validationSchema.required' />),
            payable_id: yup.number()
              .nullable()
              .transform((value, originalValue) => {
                // Handle null, undefined, empty string
                if (originalValue === null || originalValue === undefined || originalValue === '') {
                  return null
                }
                return value
              })
              .typeError(<FormattedMessage id='validationSchema.required' />)
              .required(<FormattedMessage id='validationSchema.required' />)
          })
        )
      }).test(
        'at-least-one-rule-field',
        <FormattedMessage id='validationSchema.promocode.rule.atLeastOne' />,
        function (value) {
          // If any field is filled, require at least one complete rule
          const hasUserId = !!value.user_id && value.user_id > 0
          const hasExternalEntity = !!value.external_entity_reference && !!value.external_entity_type
          const hasUserGroups = Array.isArray(value.user_group_ids) && value.user_group_ids.length > 0
          const hasExternalEntityGroups = Array.isArray(value.external_entity_group_ids) && value.external_entity_group_ids.length > 0
          const hasPayables = Array.isArray(value.payables) && value.payables.length > 0

          return hasUserId || hasExternalEntity || hasUserGroups || hasExternalEntityGroups || hasPayables
        }
      )
    )
})
export const userGroupBulkImportFormValidation = yup.object().shape({
  userGroupsFile: yup.mixed().required(<FormattedMessage id='validationSchema.required' />)
})

export const externalEntityGroupBulkImportFormValidation = yup.object().shape({
  externalEntityGroupsFile: yup.mixed().required(<FormattedMessage id='validationSchema.required' />)
})

export const promocodeBulkImportFormValidation = yup.object().shape({
  promocodesFile: yup.mixed().required(<FormattedMessage id='validationSchema.required' />)
})